export default "__VITE_ASSET__DmUtEfzI__"